import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

// should match BackgroundProcessStatusDao.kt:MAX_UNPROCESSED_RESULTS
const MAX_RESULTS = 100

const Unprocessed = Backbone.View.extend({

	/**
	 * Dialog displaying unprocessed background items, e.g. scorecards or
	 * operations (aka commands) (#24189)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.unprocessed the things that are unprocessed
	 */
	initialize: function(options = {}) {
		this.options = options

		/* uncomment to simulate more results than MAX_RESULTS
		this.options.unprocessed = []
		for (var i=0; i<MAX_RESULTS+3; i++) {
			this.options.unprocessed.push({})
		}
		*/
	},

	render: function() {
		this.$el.empty().append(this.template(this.context()))

		let noneUnprocessed = _.isEmpty(this.options.unprocessed)
		this.$('.none-message').toggleClass('is-not-displayed',
			!noneUnprocessed)
		this.$('table').toggleClass('is-not-displayed',
			noneUnprocessed)
		this.$('.panel').toggleClass('panel-with-table',
			!noneUnprocessed)

		// display "Only showing the first X results" if appropriate
		let msg = i18n.get('admin.backgroundProcessStatus.firstResults', MAX_RESULTS)
		this.$('.banner')
			.text(msg)
			.toggleClass('is-not-displayed',
				_.size(this.options.unprocessed) < MAX_RESULTS)
		return this
	},

	context: function() {
		return {
			unprocessed: this.options.unprocessed,
			noneMessage: i18n.get('common.thereAreNo', this.unprocessedDescKey)
		}
	}

})

export default Unprocessed

Unprocessed.__filename__ = 'admin/background-processes/unprocessed.js'
